<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>App verziók</span>
      <el-button
        v-can="'appversion.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/app-versions/add')"
      >
        Új app verzió
      </el-button>
    </div>
    <appVersion-list />
    <template v-if="$route.meta.showAddAppVersionDialog">
      <AppVersionDialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateAppVersionDialog">
      <AppVersionDialog
        :app-version-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import AppVersionDialog from '../components/appVersions/Dialog';
  import AppVersionList from '../components/appVersions/List';

  export default {
    components: {
      AppVersionDialog,
      AppVersionList,
    },
  };
</script>
